import { render, staticRenderFns } from "./VisitsStat.vue?vue&type=template&id=611b037c"
import script from "./VisitsStat.vue?vue&type=script&lang=js"
export * from "./VisitsStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports